/* eslint-disable jsx-a11y/no-noninteractive-element-to-interactive-role */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
import React, { useRef } from 'react';
import { KeyBoardAction } from '../../commonUtil/constants';

const RadioButton = (props) => {
    const { id, name, value, onChange, isChecked, labelMessage, highlightColor } = props;
    const inputRef = useRef(null);

    const onClickRadio = (e) => {
        if (e.keyCode === KeyBoardAction.enter && inputRef) {
            inputRef.current.click();
        }
    };

    return (
        <label tabIndex={0}
            role="radio"
            aria-checked={isChecked}
            onKeyDown={onClickRadio}
            htmlFor={id}
            className="seismic-engagement-viewer-radio-container">
            {labelMessage}
            <input
                tabIndex={-1}
                ref={inputRef}
                id={id}
                name={name}
                type="radio"
                value={value}
                onChange={onChange}
                checked={isChecked} />
            <span className="seismic-engagement-viewer-radio-checkmark">
                {isChecked && <span className="checked-dot" style={{ backgroundColor: highlightColor }} />}
            </span>
        </label>
    );
};

export default RadioButton;
